<template>
  <div class="cont">
    <!-- <div class="top">
      <el-row :gutter="10" class="sort">
        <el-col :span="6" >
          <div class="sort-item">
            <div style="margin-bottom:29px;color: #999999 ;line-height: 24px;">客户服务</div>
            <div>
              <div
                class="icon-cont"
                @mouseover="hover1hover  "
                @mouseleave="hover1leave "
                :class="{ active: hover1 }"
              >
                <el-image
                  style="width: 36px; height: 36px"
                  :src=" src1  "
                  fit="contain">
                </el-image>
                <div
                  style="font-size: 12px;;line-height: 28px;"
                >
                  在线客服
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" >
          <div class="sort-item">
            <div style="margin-bottom:29px;color: #999999 ;line-height: 24px;">关注我们</div>
            <div style="display:flex">
              <el-popover
                placement="left"
                width="200"
                trigger="hover">
                <div>
                  <el-image
                      style="width: 200px; height: 200px;"
                      :src=" this.common.publicUrl + '/profile/avatar/u29.png' "
                      fit="contain">
                  </el-image>
                </div>
                <div class="icon-cont"
                  style="margin-right:10px"
                  @mouseover="hover2hover  "
                  @mouseleave="hover2leave "
                  :class="{ active: hover2 }"
                  slot="reference"
                >
                  <el-image
                      style="width: 36px; height: 36px"
                      :src=" src2 "
                      fit="contain">
                  </el-image>
                  <div style="font-size: 12px;line-height: 28px;">
                    公众号
                  </div>
                </div>
              </el-popover>






              <div class="icon-cont"
                @mouseover="hover3hover  "
                @mouseleave="hover3leave "
                :class="{ active: hover3 }"
              >
                <el-image
                    style="width: 36px; height: 36px"
                    :src=" src3 "
                    fit="contain">
                </el-image>
                <div style="font-size: 12px;line-height: 28px;">
                  微博
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="sort-item">
            <div style="margin-bottom:19px;color: #999999 ;line-height: 24px;">微信小程序</div>
            <div style="display:flex;align-items:center">
              <el-image
                  style="width: 100px; height: 100px;margin-right:24px"
                  :src=" this.common.publicUrl + '/profile/avatar/u29.png' "
                  fit="contain">
              </el-image>
              <div style="width:85px;font-size: 12px;color: #999999 ;line-height: 20px;">
                微信扫描二维码使用小程序商城
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" >
          <div class="sort-item">
            <div style="margin-bottom:30px;color: #999999 ;line-height: 24px;">服务热线</div>
            <div style="font-size: 20px;font-weight: 700;color: #666666;line-height: 22px;margin-bottom:7px">400-0000-000</div>
            <div style="font-size: 14px;color: #999999 ;line-height: 20px;margin-bottom:8px">周一至周日 8:00-18:00</div>
            <div style="font-size: 14px;color: #999999 ;line-height: 20px;">（仅收市话费）</div>

          </div>
        </el-col>
      </el-row>

    </div> -->
    <div class="bottom">
      CopyRight @ DIXCEL中国 {{year}}

    </div>
  </div>


</template>

<script>

export default {
  name: "ContBottom" ,
  data() {
    return {
      active : '' ,
      year : undefined ,
      src1 : this.common.publicUrl + '/profile/avatar/zxkf.png' ,
      src2 : this.common.publicUrl + '/profile/avatar/wx.png' ,
      src3 : this.common.publicUrl + '/profile/avatar/weibo.png',
      hover1 : false ,
      hover2 : false ,
      hover3 : false ,

    }
  },
  created(){
    this.year = new Date().getFullYear();
  },
  methods: {


    hover1hover (){
      this.hover1 = true
      this.src1 = this.common.publicUrl + '/profile/avatar/zxkf1.png'
    },
    hover1leave(){
      this.hover1 = false
      this.src1 = this.common.publicUrl + '/profile/avatar/zxkf.png'
    },
    hover2hover(){
      this.hover2 = true
      this.src2 = this.common.publicUrl + '/profile/avatar/wx1.png'
    },
    hover2leave(){
      this.hover2 = false
      this.src2 = this.common.publicUrl + '/profile/avatar/wx.png'
    },
    hover3hover (){
      this.hover3 = true
      this.src3 = this.common.publicUrl + '/profile/avatar/weibo1.png'
    },
    hover3leave(){
      this.hover3 = false
      this.src3 = this.common.publicUrl + '/profile/avatar/weibo.png'
    }
  } ,
};
</script>

<style lang="stylus" scoped>
.cont{
  border-top : 1px solid lightgray
  background-color #fff

}
  .top{
    height 250px;
    width: 1200px;
    margin: 0 auto;
  }
    .sort-item{
      justify-content center
      display flex
      flex-direction column
      align-items  center
      height 250px
    }
      .icon-cont{
        height 80px
        width 80px
        border 1px solid rgb(237, 237, 237);
        display flex
        flex-direction column
        justify-content center
        align-items:center
        color : #999999
      }
      .icon-cont.active{
        color : #f90000
      }
  .bottom {
    background-color : #333
    line-height 150px;
    height 150px
    color #828282
    text-align center
  }
</style>
